import { render } from "./oncology_imaging.vue?vue&type=template&id=42768dde&scoped=true"
import script from "./oncology_imaging.vue?vue&type=script&lang=js"
export * from "./oncology_imaging.vue?vue&type=script&lang=js"

import "./oncology_imaging.vue?vue&type=style&index=0&id=42768dde&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42768dde"]])

export default __exports__